var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightCircleArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16129 7.16129 0 16 0C24.8387 0 32 7.16129 32 16C32 24.8387 24.8387 32 16 32C7.16129 32 0 24.8387 0 16ZM16 29.9355C23.6581 29.9355 29.9355 23.7355 29.9355 16C29.9355 8.34194 23.7355 2.06452 16 2.06452C8.34194 2.06452 2.06452 8.26452 2.06452 16C2.06452 23.6581 8.26452 29.9355 16 29.9355ZM16.8065 23.9677L24.2323 16.5484C24.5355 16.2452 24.5355 15.7548 24.2323 15.4516L16.8065 8.03226C16.5032 7.72903 16.0129 7.72903 15.7097 8.03226L15.2645 8.47742C14.9613 8.78065 14.9613 9.28387 15.2774 9.58065L20.8 14.9032H8.51613C8.09032 14.9032 7.74194 15.2516 7.74194 15.6774V16.3226C7.74194 16.7484 8.09032 17.0968 8.51613 17.0968H20.7935L15.271 22.4194C14.9613 22.7226 14.9548 23.2194 15.2581 23.5226L15.7032 23.9677C16.0129 24.271 16.5032 24.271 16.8065 23.9677Z",
    fill: "#0e0333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightCircleArrow);
export default __webpack_public_path__ + "static/media/right-circle-arrow.2d6cc70d3d501c09a3fe36ba89d2584f.svg";
export { ForwardRef as ReactComponent };